import React from 'react';
import { Redirect, Route, withRouter } from 'react-router';
import { connect } from 'react-redux';
import OverviewShell from '../overview_shell/OverviewShell';

const AttentionDashboardOverviewPage = ({ childRoutes }): React.ReactElement => {
	return (
		<>
			<Route
				path="/buyer/dashboards/overview"
				exact={true}
				render={() => (
					<Redirect
						to={{
							pathname: '/buyer/dashboards/overview/all',
						}}
					/>
				)}
			/>
			<OverviewShell
				title="Dashboard"
				tabs={[]}
				onTabChange={() => {}}
				checkTabActive={() => false}
				childRoutes={childRoutes}
			/>
		</>
	);
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = () => ({});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(AttentionDashboardOverviewPage)
);
